/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { ApiTdhGrantStatus } from '../models/ApiTdhGrantStatus';
import { ApiTdhGrantTargetChain } from '../models/ApiTdhGrantTargetChain';
import { HttpFile } from '../http/http';

export class ApiTdhGrant {
    'id': string;
    'grantor': ApiProfileMin;
    'target_chain': ApiTdhGrantTargetChain;
    'target_contract': string;
    /**
    * List of token numbers. Each element can also be a span in form of start-end. All tokens if empty.
    */
    'target_tokens': Array<string>;
    'created_at': number;
    'valid_from': number | null;
    'valid_to': number | null;
    'tdh_rate': number;
    'error_details': string | null;
    'status': ApiTdhGrantStatus;
    /**
    * If true then the grant must be covered with lock contracts
    */
    'is_irrevocable': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "grantor",
            "baseName": "grantor",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "target_chain",
            "baseName": "target_chain",
            "type": "ApiTdhGrantTargetChain",
            "format": ""
        },
        {
            "name": "target_contract",
            "baseName": "target_contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "target_tokens",
            "baseName": "target_tokens",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "valid_from",
            "baseName": "valid_from",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "valid_to",
            "baseName": "valid_to",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh_rate",
            "baseName": "tdh_rate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "error_details",
            "baseName": "error_details",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ApiTdhGrantStatus",
            "format": ""
        },
        {
            "name": "is_irrevocable",
            "baseName": "is_irrevocable",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiTdhGrant.attributeTypeMap;
    }

    public constructor() {
    }
}



